import { Link } from 'react-router-dom';
import { Facebook, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#111111] border-t border-[#DAA520]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-8 sm:py-12">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12">
          {/* Logo & Tagline */}
          <div className="flex flex-col gap-4 sm:col-span-2 md:col-span-1">
            <Link to="/">
              <img 
                src="https://customer-assets.emergentagent.com/job_jailer-campaign/artifacts/yph5ki0r_MC_Jailer_Logo_TR.png"
                alt="Barry Howell for Marshall County Jailer"
                className="h-12 sm:h-16 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Our County's Stronger When The Jail's In Order.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#DAA520] font-bold uppercase tracking-wider mb-3 sm:mb-4 font-['Barlow_Condensed']">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-gray-400 hover:text-[#DAA520] transition-colors text-sm">
                Home
              </Link>
              <Link to="/about" className="text-gray-400 hover:text-[#DAA520] transition-colors text-sm">
                About Barry
              </Link>
              <Link to="/platform" className="text-gray-400 hover:text-[#DAA520] transition-colors text-sm">
                Platform
              </Link>
              <Link to="/stay-informed" className="text-gray-400 hover:text-[#DAA520] transition-colors text-sm">
                Stay Informed
              </Link>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-[#DAA520] font-bold uppercase tracking-wider mb-3 sm:mb-4 font-['Barlow_Condensed']">
              Connect
            </h4>
            <div className="flex flex-col gap-3">
              <a 
                href="https://www.facebook.com/people/Barry-Howell-For-Marshall-County-Jailer/61582275503939/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-[#DAA520] transition-colors text-sm"
                data-testid="footer-facebook-link"
              >
                <Facebook className="w-4 h-4" />
                Follow on Facebook
              </a>
              <a 
                href="mailto:barry@mcjailer.com" 
                className="flex items-center gap-2 text-gray-400 hover:text-[#DAA520] transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                Contact Campaign
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-[#DAA520]/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-center sm:text-left">
            <p className="text-gray-500 text-xs">
              © {new Date().getFullYear()} Barry Howell for Marshall County Jailer. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs">
              Paid for by Barry Howell for Marshall County Jailer
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
